/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
*/
import { useRef, type JSX } from 'react'
import { type Mesh } from 'three'

import { useColorMapGLTF } from '@hooks'

import { LocomotiveMechanism } from './LocomotiveMechanism'

export const WHEEL_Y = 0.27
export const WHEEL_FRONT_Z = -0.093
export const WHEEL_REAR_Z = -0.693
export const WHEEL_X = 0.425

interface GLTFResultNodes {
  ['train-locomotive-b']: Mesh
  wheel: Mesh
  wheel001: Mesh
  wheel002: Mesh
  wheel003: Mesh
  ['wheels-front']: Mesh
}

type LocomotiveModelProps = JSX.IntrinsicElements['group'] & { vehicleId?: string }

export function LocomotiveModel({ vehicleId, ...props }: LocomotiveModelProps) {
  const { nodes, material } = useColorMapGLTF<GLTFResultNodes>(
    '/models/train/train-locomotive-b.glb',
    'train',
  )

  const bodyRef = useRef<Mesh>(null!)

  const rightWheelFrontRef = useRef<Mesh>(null!)
  const rightWheelRearRef = useRef<Mesh>(null!)

  const leftWheelFrontRef = useRef<Mesh>(null!)
  const leftWheelRearRef = useRef<Mesh>(null!)

  return (
    <group {...props}>
      <mesh
        ref={bodyRef}
        castShadow
        receiveShadow
        geometry={nodes['train-locomotive-b'].geometry}
        material={material}
      >
        <mesh
          receiveShadow
          ref={rightWheelFrontRef}
          geometry={nodes.wheel.geometry}
          material={material}
          position={[WHEEL_X, WHEEL_Y, WHEEL_FRONT_Z]}
        />
        <mesh
          receiveShadow
          ref={rightWheelRearRef}
          geometry={nodes.wheel001.geometry}
          material={material}
          position={[WHEEL_X, WHEEL_Y, WHEEL_REAR_Z]}
        />
        <mesh
          receiveShadow
          ref={leftWheelFrontRef}
          geometry={nodes.wheel002.geometry}
          material={material}
          position={[-WHEEL_X, WHEEL_Y, WHEEL_FRONT_Z]}
        />
        <mesh
          receiveShadow
          ref={leftWheelRearRef}
          geometry={nodes.wheel003.geometry}
          material={material}
          position={[-WHEEL_X, WHEEL_Y, WHEEL_REAR_Z]}
        />
        <mesh
          receiveShadow
          geometry={nodes['wheels-front'].geometry}
          material={material}
          position={[0, 0, 0.553]}
        />
      </mesh>

      {vehicleId && (
        <LocomotiveMechanism
          vehicleId={vehicleId}
          leftWheelFrontRef={leftWheelFrontRef}
          leftWheelRearRef={leftWheelRearRef}
          rightWheelFrontRef={rightWheelFrontRef}
          rightWheelRearRef={rightWheelRearRef}
          wheelX={WHEEL_X}
          wheelY={WHEEL_Y}
          wheelFrontZ={WHEEL_FRONT_Z}
          wheelRearZ={WHEEL_REAR_Z}
        />
      )}
    </group>
  )
}

useColorMapGLTF.preload('/models/train/train-locomotive-b.glb')
